import { render } from "./TextArea.vue?vue&type=template&id=2cbe606e"
import script from "./TextArea.vue?vue&type=script&lang=js"
export * from "./TextArea.vue?vue&type=script&lang=js"
script.render = render

export default script